import React from "react";
import { FaCreditCard, FaKey, FaIdCard } from "react-icons/fa";
import "../App.css";

const services = [
  {
    icon: <FaCreditCard />,
    title: "Contactless Payments",
    description:
      "Secure NFC payment processing for retail, hospitality, and enterprise. Fast transactions with advanced fraud protection and real-time analytics.",
  },
  {
    icon: <FaKey />,
    title: "Access Control Systems",
    description:
      "Smart NFC authentication for buildings, vehicles, and secure areas. Seamless access management with multi-factor security and audit trails.",
  },
  {
    icon: <FaIdCard />,
    title: "Digital Identity Solutions",
    description:
      "NFC-powered digital credentials, employee badges, and customer loyalty programs. Secure identity verification with blockchain integration and privacy protection.",
  },
];

export const Services = () => (
  <section id="services" className="text-center">
    <div className="container">
      <div className="section-title">
        <h2>Our Services</h2>
      </div>
      <div className="row">
        {services.map(({ icon, title, description }, index) => (
          <div key={index} className="col-md-4">
            <div className="icon-circle">{icon}</div>
            <div className="service-desc">
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
